import { render, staticRenderFns } from "./ProcessTypeList.vue?vue&type=template&id=6e5b4bda&"
import script from "./ProcessTypeList.vue?vue&type=script&lang=js&"
export * from "./ProcessTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports